import { FormProvider } from 'react-hook-form'
import { UserCard } from './components/UserCard'
import { UserForm } from './components/UserForm'
import { PasswordAdminChange } from './components/UserForm/components/PasswordAdminChange'
import { usePerfil } from './usePerfil'
import { UserPin } from './components/UserPin'

// TODO: Credliber usa um padrão de tabs nesse arquivo, confirmar depois qual prevalecerá

export const Perfil = () => {
  const { methods, user } = usePerfil()

  // const tabs = useMemo(
  //   () => [
  //     {
  //       value: 'perfil',
  //       label: 'Perfil',
  //       content: (
  //         <FormProvider {...methods}>
  //           <UserForm />
  //         </FormProvider>
  //       ),
  //     },
  //     {
  //       value: 'withdraws',
  //       label: 'Saques de comissão',
  //       content: <SellerCommissionPage />,
  //     },
  //   ],
  //   [methods],
  // )

  return (
    <div className="mt-8 flex flex-col items-start">
      <h1 className="text-2xl font-semibold">Meu perfil</h1>

      <div className="flex w-full flex-col items-start gap-6 md:flex-row lg:gap-12">
        <div className="mt-2 w-full space-y-4">
          {user && (
            <UserCard
              createdAt={user?.createdAt}
              name={user?.name}
              profileImageUrl={user?.profileImageUrl}
            />
          )}
          <PasswordAdminChange />
          <UserPin user={user} />
        </div>
        <div className="w-full">
          <FormProvider {...methods}>
            <UserForm />
          </FormProvider>
        </div>
      </div>
    </div>
  )
}
